<div class="govuk-grid-row">
    <div class="govuk-grid-column-full-width">
        <form [formGroup]="amountForm">
            <fieldset class="govuk-fieldset">
                <ng-container *ngIf="action === 'extra_items'">
                    <ng-container *ngFor="let item of extraItems" formGroupName="extraItems">
                        <div class="govuk-form-group">
                            <label class="govuk-label" [for]="item.item_id">
                                {{ item.item_description }}
                            </label>
                            <select class="govuk-select" [id]="item.item_id" [name]="item.item_id" formControlName="{{ item.item_id }}">
                                <option *ngFor="let i of extraCount" value="{{ i }}">{{ i }}</option>
                            </select>
                        </div>
                    </ng-container>
                </ng-container>
                <div class="govuk-form-group" [class.govuk-visually-hidden]="action === 'balance'">
                    <label class="govuk-label" for="amount">
                        Amount to pay
                    </label>
                    <div class="govuk-input__wrapper">
                        <div class="govuk-input__prefix" aria-hidden="true">£</div>
                        <input class="govuk-input govuk-input--width-5" id="amount" name="amount" formControlName="amount" type="number" [readonly]="amountDisabled">
                    </div>
                    <ng-container *ngIf="form['amount'].errors">
                        <p class="govuk-error-message" *ngIf="form['amount'].errors.amountTooLow">
                            <span class="govuk-visually-hidden">Error:</span> Specified amount is too low
                        </p>
                        <p class="govuk-error-message" *ngIf="form['amount'].errors.amountTooHigh">
                            <span class="govuk-visually-hidden">Error:</span> Specified amount is greater than the remaining balance
                        </p>
                    </ng-container>
                </div>
                <div *ngIf="revCodeError"
                     class="govuk-notification-banner app-notification-banner"
                     role="alert"
                     aria-labelledby="payment-amount-rev-code-error-title"
                     data-module="govuk-notification-banner"
                     data-test="payment-amount-rev-code-error">
                    <div class="govuk-notification-banner__header">
                        <h2 class="govuk-notification-banner__title" id="payment-amount-rev-code-error-title">
                            Important
                        </h2>
                    </div>
                    <div class="govuk-notification-banner__content">
                        <p class="govuk-notification-banner__heading">
                            If you experience any problems with making a payment for your ceremony, please contact us. The best way is your
                            <a class="govuk-link govuk-notification-banner__link" [routerLink]="communicationLink">myWestminster</a> account.
                        </p>
                    </div>
                </div>
                <div *ngIf="paymentStartError"
                     class="govuk-notification-banner app-notification-banner"
                     role="alert"
                     aria-labelledby="payment-amount-start-error-title"
                     data-module="govuk-notification-banner"
                     data-test="payment-amount-start-error">
                    <div class="govuk-notification-banner__header">
                        <h2 class="govuk-notification-banner__title" id="payment-amount-start-error-title">
                            Important
                        </h2>
                    </div>
                    <div class="govuk-notification-banner__content">
                        <p class="govuk-notification-banner__heading">
                            We could not start your payment, so you have not been charged. Select
                            &ldquo;Start again&rdquo; to reload your account and try again, or contact us via your
                            <a class="govuk-link govuk-notification-banner__link" [routerLink]="communicationLink">myWestminster</a> account if the problem continues.
                        </p>
                    </div>
                </div>
                <div class="govuk-form-group">
                    <button *ngIf="!paymentStartError" (click)="submit()" type="submit" class="govuk-button govuk-button--primary" data-module="govuk-button" [disabled]="!amountForm.valid">
                        Pay
                    </button>
                    <button *ngIf="paymentStartError" (click)="restart()" type="button" class="govuk-button govuk-button--primary" data-module="govuk-button">
                        Start again
                    </button>
                </div>
            </fieldset>
        </form>
    </div>
</div>